import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from "@reduxjs/toolkit/query/react";

import authReducer from "./slice/authSlice";

import { authApi } from './services/authApi';
import { commonApi } from './services/commonApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      commonApi.middleware,
    ),
});

setupListeners(store.dispatch)
